"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const drippingFormSidebar_1 = __importDefault(require("./drippingFormSidebar"));
exports.default = drippingFormSidebar_1.default;
